import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
    selector: '[wdxNavLink]',
    standalone: false,
})
export class WdxNavLinkDirective {
    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);

    constructor() {
        this.renderer.addClass(this.elementRef.nativeElement, 'nav-link');
        this.renderer.addClass(this.elementRef.nativeElement, 'd-flex');
        this.renderer.addClass(
            this.elementRef.nativeElement,
            'align-items-center',
        );
        this.renderer.addClass(
            this.elementRef.nativeElement,
            'justify-content-start',
        );
    }
}
